import { DirectiveOptions } from 'vue';

const noAutoComplete: DirectiveOptions = {

    inserted: function (el) {
        
        $(el).find(".multiselect__input").attr("autocomplete", "nope");

    }
};

export default noAutoComplete;